import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { Navigate } from "react-router-dom";
import moment from 'moment';
import '../../css/ticket.css';
const common = require('../common/common.jsx');
const ticketCommon = require('../common/ticketCommon.jsx');
const env = require("../../config.js").default;

try {
    require("moment/locale/" + common.getLanguageMoment() + ".js");
} catch (err) {
    require("moment/locale/en-gb.js");
}

class TicketTableMVFirebird extends React.Component {
    constructor(props) {
        super(props);
        this.state={}
        this.state.pathname = this.props.pathname;
        this.state.recordTabella = {};
        this.state.items = [];
        this.state.NTELA = this.props.NTELA ? this.props.NTELA : ''
        this.state.items_total = {}
        this.state.userInfo = {};
        this.state.userInfo.roles = [];
        this.changePage = this.changePage.bind(this);
        this.state.userInfo.userInfo = {};
        this.state.customTag = <></>;
        this.state.stati_ticket = []
        this.state.folder = this.props.folder
        this.state.cfold = 'ticket'
        this.state.pagination = {
            actualPage: parseInt(common.getParam("page", "", 1)) - 1,
            prev: false,
            next: false,
        }
        if (this.state.pagination.actualPage > 1)
            this.state.pagination.prev = true;
        this.state.paginazioneCustomButtons = [];
        this._isMounted = false;
        this.state.is_multibrand = this.props.is_multibrand;
        this.state.is_admin = this.props.is_admin;
        //this.state.dates = this.props.dates
        this.state.mostraNazione = this.props.mostraNazione
        this.state.marcaDefault = common.get_localStorage("valoreMarca") !== undefined ?
            common.get_localStorage("valoreMarca")
            : this.props.marche_attive !== undefined && this.props.marche_attive.length > 1 && this.state.is_multibrand === false ?
                this.props.marcaDefault
                :
                this.props.marche_attive[0].ZFORN;

        common.getUserInfo().then(userInfo => {
            this.setState({ userInfo: userInfo });
        })
        this.state.tickets_number = 0
        this.state.items_showed = 0
        this.state.start = 0
        this.state.length = 0
        this.TicketTableFirebirdDrawCallback = this.TicketTableFirebirdDrawCallback.bind(this);
    }



    componentDidMount(props) {
        const $ = window.$;
        this._isMounted = true;
        $(document).ready(function () {
            $(window).resize(function () {
                window.setTimeout(function () {
                    if ($('#tickets_firebird_table').is(":visible"))
                        $('#tickets_firebird_table').DataTable()?.columns?.adjust();
                }, 600);
            });
        });

        var apiUrl = common.getTicketBackendUrl(this.state.pathname);
        var isTicketvehicle = true


        const caColPosition = [
            "caCAVTL",
            "caNTELA",
            "caDDOCU",
            "caCAVTI",
            "caDCAUS",
            "caUINSR",
            "caULUPD",
        ];

        const BATCHING_SIZE = 25;
        
        function get_row_counter(message) {
            let el = document.querySelector('#tickets_firebird_table_paginate');
            let div = document.createElement('div');
            div.textContent = message;
            el.before(div);
        }
        common.get_UX_page(this.state.folder).then(dataDB =>{
            if (dataDB['result'] !== undefined){
                if (dataDB['result']['Table'] !== undefined){
                    if (dataDB['result']['Table']["OrderSettings"] !== undefined){
                        var dictOrder = []
                        dataDB['result']['Table']["OrderSettings"].forEach(subArray => {
                            dictOrder.push([caColPosition.indexOf("ca" + subArray[0]), subArray[1]])
                        });
                    }
                }
            }
            if (dataDB['result'] !== undefined){
                this.getCountTicketFirebird(dataDB['result'])
            }else{
                this.getCountTicketFirebird()
            }
            $('#tickets_firebird_table').DataTable({
                "retrieve": true,
                "responsive": false,
                "lengthChange": false,
                "width": "100%",
                "scrollX": true,
                "autoWidth": true,
                "sScrollX": "100%",
                "sScrollXInner": "100%",
                "pageLength": BATCHING_SIZE,
                "displayStart": this.state.pagination.actualPage * BATCHING_SIZE,
                "pagingType": "simple",
                "dom": "lfrti",
                "buttons": false,
                "filter": true,
                "processing": true,
                "ordering": true,
                "order": dataDB['result'] !== undefined && dataDB['result']['Table'] !== undefined ? dataDB['result']['Table']["OrderSettings"] !== undefined ? dictOrder : [[caColPosition.indexOf("caULUPD"), "desc"]] : [[caColPosition.indexOf("caULUPD"), "desc"]],
                "searching": true,
                "search": {
                    "search": dataDB['result'] !== undefined && dataDB['result']['Table'] !== undefined ? dataDB['result']['Table']['SearchValue'] !== undefined ? dataDB['result']['Table']['SearchValue'] : '' : ''
                },
                "info": false,
                serverSide: true,
                ajax: {
                    url: apiUrl,
                    type: 'GET',
                    data: (data) => {
                        var table = $("#tickets_firebird_table").DataTable();
                        $("#tickets_firebird_table_filter input").unbind()
                        var folder = 'ticket'
                        $("#tickets_firebird_table_filter input").bind('input', (delay( (e) => {
                            table.search($("#tickets_firebird_table_filter input").val()).draw();
                            var value = $("#tickets_firebird_table_filter input").val()
                            common.add_UX_data(folder, "Table", "SearchValue", $("#tickets_firebird_table_filter input").val())
                            let pagination = this.state.pagination;
                            pagination.actualPage = 0
                            this.setState({pagination : pagination})
                            this.tablePageChange(0)
                            ticketCommon.addDot(value, $('#tickets_firebird_table_filter > label'))
                            this.getCountTicketFirebird(null, value)
                            return;
                        }, 1000)))
    
                        
                        var orderDbIndex = []
                        var orderSettings = $('#tickets_firebird_table').DataTable().order();
                        var order = "";
                        for (var i = 0; i < orderSettings.length; i++) {
                            if (order !== "")
                            order = order + ",";
                            var orderColumn = $('#tickets_firebird_table').DataTable().column(orderSettings[i][0]).dataSrc();
                            order = order + "{{" + orderColumn + "}} " + orderSettings[i][1].toUpperCase();
                            var appo = []
                            appo.push(orderColumn)
                            appo.push(orderSettings[i][1])
                            orderDbIndex.push(appo)
                        }

                        data.OrderPage = order
                        //common.add_UX_data(this.state.folder, "Table", "OrderSettings", orderDbIndex)

                        if(this.state.NTELA !== undefined && this.state.NTELA !== ''){
                            data.NTELA = this.state.NTELA
                        }
                    },
                    dataSrc: (json) => {
                        var table = $("#tickets_firebird_table").DataTable();
                        $("#tickets_firebird_table_last").hide();
                        var orderDbIndex = []
                        var orderSettings = $('#tickets_firebird_table').DataTable().order();
                        var order = "";
                        for (var i = 0; i < orderSettings.length; i++) {
                            if (order !== "")
                                order = order + ",";
                            var orderColumn = $('#tickets_firebird_table').DataTable().column(orderSettings[i][0]).dataSrc();
                            order = order + "{{" + orderColumn + "}} " + orderSettings[i][1].toUpperCase();
                            var appo = []
                            appo.push(orderColumn)
                            appo.push(orderSettings[i][1])
                            orderDbIndex.push(appo)
                        }
                        var folder = 'ticket'
                        table.on('order', function () {
                            common.add_UX_data(folder, "Table", "OrderSettings", orderDbIndex)
                        })
                        let pagination = this.state.pagination;
                        if (table.page.len() > json.data.length) {
                            this.state.pagination.next = false;
                        } else {
                            this.state.pagination.next = true;
                        }
                        pagination.prev = (table.page.info()["page"] > 0);
                        this.setState({ pagination: pagination });
                        return json.data;
                    },
                },
    
                columns: [
                    {
                        data: "CAVTL",
                        "class": "never",
                        "render": (data, type, row) => {
                            if (row.CAVTL !== undefined && row.CAVTL === '00')
                                return "0"
                            else
                                return "1";
                        },
                        "visible": false,
                    },
                    {
                        title: common.getTrad("Telaio"),
                        data: "NTELA",
                        width: "10px",
                        visible: isTicketvehicle,
                        "targets": caColPosition.indexOf("caNTELA"),
                        "class": 'vin_vehicle sorting',
                        "render": (data, type, row) => {
                            if (row.NTELA) {
                                return `<span class="fastCopy" data-value="${row.NTELA}"><i class="far fa-copy"></i>&nbsp;&nbsp;${row.NTELA}</span>`;
                            } else {
                                return "";
                            }
                        }
                    },
                    {
                        title: common.getTrad("Titolo"),
                        data: "DDOCU",
                        "width": "30px",
                        "class": 'sortable_title sorting',
                        "targets": caColPosition.indexOf("caDDOCU"),
                        "render": (data, type, row) => {
                            var ret = '';
                            if (row.DDOCU.length > 50) {
                                ret = <>{common.truncateOnWord(row.DDOCU, 55)}</>;
                            } else {
                                ret = <>{row.DDOCU}</>;
                            }
    
                            return ReactDOMServer.renderToStaticMarkup(
                                <>
                                    <small className="datatableSmall">{row.ID}</small>
                                    {ret}
                                </>
                            )
                        }
                    },
                    {
                        title: common.getTrad("Stato"),
                        data: "CAVTI",
                        width: "10px",
                        "class": 'review_state sorting',
                        "targets": caColPosition.indexOf("caCAVTI"),
                        "render": function (data, type, row) {
                            if (row.CAVTI.indexOf("90") > -1) {
                                return "<span class=\"closed\" style=\"font-weight:normal;background: #dc3545;box-shadow:1px 1px 3px -1px #000;padding: 0.25em 0.5em;color: #fff;\" title=\"" + common.getTrad("Chiuso") + "\"><i class=\"fas fa-envelope\"></i></span>";
                            }else {
                                return "<span style=\"font-weight:normal;background: #28a745;box-shadow:1px 1px 3px -1px #000; padding: 0.25em 0.5em;color: #fff;\" title=\"" + common.getTrad("Aperto") + "\"><i class=\"fas fa-envelope-open-text\"></i></span>";
                            }
                        }
                    },
                    {
                        data: 'CAVTI',
                        "visible": false,
                    },
                    {
                        title: common.getTrad("Tipo"),
                        data: "DCAUS",
                        "targets": caColPosition.indexOf("caDCAUS"),
                        width: "10px",
                        "render": (data, type, row) => {
    
                            if (row.DCAUS !== null && row.DCAUS !== undefined)
                                return common.truncateOnWord(row.DCAUS, 30)
                            else
                                return ""
                        }
                    },
                    {
                        title: common.getTrad("Data Ins."),
                        width: "10px",
                        data: "UINSR",
                        "targets": caColPosition.indexOf("caUINSR"),
                        "class": 'created sorting',
                        type: 'datetime-moment',
                        "render": function (data, type, row) {
                            return moment(row.UTRAS ? row.UTRAS : row.UINSR).format('L') + "\n" + '<small class=\"datatableSmall\">' + moment(row.UTRAS ? row.UTRAS : row.UINSR).format('LT') + '</small>';
                        }
                    },
                    {
                        title: common.getTrad("Data Mod."),
                        "data": 'ULUPD',
                        width: "10px",
                        type: 'datetime-moment',
                        "targets": caColPosition.indexOf("caULUPD"),
                        "class": 'modified sorting',
                        "render": function (data, type, row) {
                            return moment(row.ULUPD).format('L') + "\n" + '<small class=\"datatableSmall\">' + moment(row.ULUPD).format('LT') + '</small>';
                        }
                    },
                ],
                "createdRow": (row, data) => {
                    $(row).find('.fastCopy').on('click', function (e) {
                        fastCopy(e, $(this));
                    });
                },
                "language": {
                    "url": env.STATIC + "lib/datatables/i18n/" + common.getLanguage() + ".lang"
                }, 
                "initComplete": function (settings, json) {
                    $("#ticketCounter").prependTo("#tickets_firebird_table_filter")
                    $("#ticketCounter").removeAttr('hidden')           
                    if (dataDB['result']){
                        if (dataDB['result']['Table']){
                            if (dataDB['result']['Table']['SearchValue'] !== undefined){
                                ticketCommon.addDot(dataDB['result']['Table']['SearchValue'], $('#tickets_firebird_table_filter > label'))
                            }
                        }
                    }
                },               
                fnRowCallback: (nRow, aData, iDisplayIndex, iDisplayIndexFull) => {
    
                    // Row click
                    $(nRow).on('click', (e) => {
                        return false
                    })


                },
                "drawCallback": this.TicketTableFirebirdDrawCallback
            })
        })
        if (common.get_localStorage("sortOrderColumnTicket") !== undefined && common.get_localStorage("sortOrderColumnTicket"))
            this.props.paginaDati.verso_ordinamento = parseInt(common.get_localStorage("sortOrderColumnTicket"))
        
    }

    TicketTableFirebirdDrawCallback(settings) {
        var $ = window.$
        var $container = $("#tickets_firebird_table_wrapper .dataTables_scrollHead").parent();
        var $scroller = $("#tickets_firebird_table_wrapper .dataTables_scrollBody");
        common.bindDragScroll($container, $scroller);
        // Use the DataTable API to get the required data
        // const tickets_number = $("#tickets_firebird_table").DataTable().settings()[0].json['tickets_number'];
        const start = $("#tickets_firebird_table").DataTable().settings()[0].json['start'];
        const items_showed = $("#tickets_firebird_table").DataTable().data().length;
        const length = start + items_showed
        // Update the state using setState
        this.setState({
            items_showed: items_showed,
            start:start + 1,
            length:length
        });
    }
    componentDidUpdate(nextProps) {
        const $ = window.$;
        let pagination = this.state.pagination;
        if (this.props.resetpagination === true) {
            pagination.actualPage = 0
            this.props.sendData(false);
        }
        if (this.props !== nextProps) {
            this.setState({ is_multibrand: nextProps.is_multibrand, is_admin : nextProps.is_admin });
        }


        if (this.state.userInfo.is_admin_ticket !== undefined && !this.state.userInfo.is_admin_ticket) {
            $("body").append('<style>.ticket_creator{display:none}</style>');
            $("body").append('<style>.user_cnazi{display:none}</style>');
        }

        $("#filtra_tickets").unbind().on('click', (e) =>{
            common.get_UX_component(this.state.folder, "Table", "SearchValue").then((value) => {
            if(value !== undefined){
                this.getCountTicketFirebird(null, value)
            }else{
                this.getCountTicketFirebird()
            }
            })
        })
    }

    changePage(id) {
        this._isMounted && this.setState({
            customTag: (<Navigate to={id} push={true} />)
        })
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    CAVTIDecode(cavti){
        if(cavti === '05'){
            return common.getTrad("Aperto")
        }else if(cavti === '11'){
            return common.getTrad("Incompleto")
        }else if(cavti === '70'){
            return common.getTrad("In lavorazione")
        }else if(cavti === '90'){
            return common.getTrad("Chiuso")
        }
    }


    getCountTicketFirebird = (data = null, searchValue = null) => {
        var params = {
            'onlyCount': 1
        }
        if(data !== null && data !== undefined){
            if (data['Table'] !== null && data['Table'] !== undefined){
                let tableData = data['Table']
                if(tableData['SearchValue']){
                    params.searchCount = tableData['SearchValue']
                }
            }
        }else{
            if (searchValue !== null) {
                params.searchCount = searchValue
            }           
        }

        let apiUrl = common.getTicketBackendUrl(this.state.pathname);
        common.apiCall(apiUrl + 'count/', "GET", params, true, false, "json").then(value => {
            this.setState({ tickets_number: value['data'][0]['NELEM'] })
        })   
    }

    tablePageChange = (pageChanging) => {
        const $ = window.$;
        let pagination = this.state.pagination;
        let table = $("#tickets_firebird_table").DataTable();
        let newPage = pagination.actualPage;

        if (pageChanging == 0)
            newPage = 0;
        if (pageChanging == 0 && pagination.prev == false)
            return
        else if (pageChanging == -1 && pagination.prev == false)
            return
        else if (pageChanging == 1 && pagination.next == false)
            return
        else
            newPage += pageChanging;

        table.page(newPage).draw(false);
        pagination.actualPage = newPage;
        window.history.replaceState({}, "", common.updateURLParameter("page", newPage + 1));
        this.setState({ pagination: pagination });
    }

    render(props) {
        return (
            <div className="tab active">
                {this.state.customTag}
                <div>
                    <div id="whiteSpace" style={{ 'paddingTop': '50px'}}></div>
                    <table id="tickets_firebird_table" className="table table-striped table-bordered dt-responsive nowrap styledTable" style={{ width: '100%' }}></table>
                    <div className="dataTables_wrapper dt-bootstrap4 no-footer">
                        <div className="row">
                            <div className="col-lg-5 col-sm-12 col-xs-12" id="ticketCounter" style={{'textAlign' : 'left', 'position' : 'absolute', 'paddingLeft': '0px'}} hidden>
                                {this.state.tickets_number > 0 ?
                                <div>
                                    <span className="dataTables_info" style={{ 'paddingTop': '.45em', 'marginLeft': '20px' }}>
                                        {common.getTrad("Risultati da") + " " + this.state.start + " " + common.getTrad("a") + " " + this.state.length + " " + common.getTrad("di") +  " " + this.state.tickets_number + " " + common.getTrad("voci")}
                                    </span>
                                </div>
                                :
                                <div>
                                    <span className="dataTables_info" style={{ 'paddingTop': '.45em' }}>
                                        {common.getTrad("Risultati") + " " + '0' + " " + common.getTrad("di") + " " + this.state.tickets_number + " " + common.getTrad("voci")}
                                    </span>
                                </div>

                                }
                            </div>

                            <div className="col-12 pt-4">
                                <div className="dataTables_paginate paging_full_numbers" id="tickets_firebird_table_paginate">
                                    <ul className="pagination">
                                        <li onClick={() => { this.tablePageChange(0) }}
                                            className={(!this.state.pagination.prev ? "disabled" : "") + " paginate_button page-item first"}
                                            title={common.getTrad("Inizio")}>
                                            <p className="page-link"><i className="fas fa-fast-backward"></i></p>
                                        </li>
                                        <li onClick={() => { this.tablePageChange(-1) }}
                                            className={(!this.state.pagination.prev ? "disabled" : "") + " paginate_button page-item previous"} id="table_DefaultTable_previous"
                                            title={common.getTrad("Precedente")}>
                                            <p className="page-link"><i className="fas fa-step-backward"></i></p>
                                        </li>
                                        <li onClick={() => { this.tablePageChange(1) }}
                                            className={(!this.state.pagination.next ? "disabled" : "") + " paginate_button page-item next"} id="table_DefaultTable_next"
                                            title={common.getTrad("Successivo")}>
                                            <p className="page-link" ><i className="fas fa-step-forward"></i></p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function delay(callback, ms) {
    var timer = 0;
    return function () {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            callback.apply(context, args);
        }, ms || 0);
    };
}

function fastCopy(e, elem) {
    var $ = window.$;
    e = e || window.event;
    e.preventDefault();
    var $icon = $(elem).find("i");
    var originalClass = $icon.attr("class");
    var originalColor = $icon.css("color");
    $icon.attr("class", "fas fa-check");
    $icon.css("color", "green");
    navigator.clipboard.writeText($(elem).text().trim());
    window.setTimeout(() => {
        $icon.attr("class", originalClass);
        $icon.css("color", originalColor);
    }, 1000);

    return false;
}

export default TicketTableMVFirebird;